import list from './list'
import edit from './edit'
import create from './create'
// import icon from '@material-ui/icons/Person'

export default { list, edit, create, options: { label: 'Clubs' } }
